import { HeatAllDTO } from "@/models/heats/heat-all.dto";
import { HeatCurrentDTO } from "@/models/heats/heat-current.dto";
import { createSlice } from "@reduxjs/toolkit";
import { get } from "lodash-es";
import { getAllHeats, getCurrentHeats } from "./heats.thunks";

interface InitialState {
	allHeats: {
		allHeatsDTO?: HeatAllDTO;
		isAllHeatsDTOLoading?: boolean;
		timerIsOn: boolean;
	};
	currentHeats: {
		currentHeatsDTO?: HeatCurrentDTO;
		currentHeatsByRootId?: HeatCurrentDTO;
		isHeatsLoading?: boolean;
	};
}

const initialState: InitialState = {
	allHeats: {
		timerIsOn: true,
	},
	currentHeats: {},
};

export const HeatsReducer = createSlice({
	name: "@heats",
	initialState,
	reducers: {
		setTimerIsOn(state, { payload }) {
			state.allHeats.timerIsOn = payload;
		},
	},
	extraReducers: (builder) => {
		builder
			// ALL
			.addCase(getAllHeats.pending, (state, action) => {
				state.allHeats = {
					isAllHeatsDTOLoading: true,
					timerIsOn: state.allHeats.timerIsOn,
				};
			})
			.addCase(getAllHeats.fulfilled, (state, action) => {
				state.allHeats = {
					isAllHeatsDTOLoading: false,
					allHeatsDTO: action.payload,
					timerIsOn: state.allHeats.timerIsOn,
				};
			})
			// CURRENT
			.addCase(getCurrentHeats.pending, (state, action) => {
				const currentState = get(state, "currentHeats", {});
				state.currentHeats = {
					...currentState,
					isHeatsLoading: true,
				};
			})
			.addCase(getCurrentHeats.fulfilled, (state, action) => {
				const currentState = get(state, "currentHeats", {});
				state.currentHeats = {
					...currentState,
					isHeatsLoading: false,
				};
				state.currentHeats = action.payload;
				const heatsByRootId: HeatCurrentDTO = {};
				Object.values(action.payload as HeatCurrentDTO).forEach((heat) => {
					if (heat.ladleId) heatsByRootId[heat.ladleId!.toString()] = heat;
				});
				state.currentHeats!.currentHeatsByRootId = heatsByRootId;
			});
	},
});

export const { setTimerIsOn } = HeatsReducer.actions;
